module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAA////////////////////////////////////////////////////////oUirmwAAAA90Uk5TADAQoP/PYJ8gQB/QsGrwmjxxpgAAAEVJREFUeJxjYAADIQjFwOyqAGGkuARABIpdPMAME3eTBLCAi0slRMDFBSbghl+AawtUgOc2RICBxXcbxJopb6D2TYQ6AADaEg+JHEdT0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-pencil.png
// module id = 309
// module chunks = 1